import * as React from 'react';
import { useEffect, useCallback, useState } from 'react';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Stack from '@mui/material/Stack';
import {
    Box, Typography, FormGroup, FormControlLabel, Checkbox
} from "@mui/material";
import Menu from '@mui/material/Menu';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as Arrow } from "../../assets/images/arrow-right.svg";
import { makeStyles } from "@mui/styles";
import { ReactComponent as TrashIcon } from "../../assets/images/portfolio/trash-alt.svg";
import { ReactComponent as BtnFilter } from "../../assets/images/btn-filter.svg";

const useStyles = makeStyles({
    btn: {
        fontSize: "18px !important",
        lineHeight: "24.59px !important",
        textDecoration: "underline !important",
        '& > svg': {
            marginLeft: "10px",
            marginBottom: "-2px",
        }
    },
    fillBlack: {
        '& > path': {
            fill: '#404349'
        },
        '& g > path': {
            fill: '#404349'
        },
    },
});

const styles = {
    td: {
        fontSize: "18px",
        lineHeight: "24.59px",
        textDecoration: "underline",
        '& > svg': {
            marginLeft: "10px",
            marginBottom: "-2px",
        }
    },
    iconBox: {
        width: "18px",
        height: "18px",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        marginRight: "9px"
    },
};

export default function MenuListPlanning(props) {
    const anchorRef = React.useRef(null);
    const { notEvaluated, evaluated, EditEvaluated, openMenu, statusOpen } = props
    const classes = useStyles();
    useEffect(() => {
        statusOpen(false);
    }, []);
    const handleToggle = () => {
        statusOpen((prevOpen) => !prevOpen)
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        statusOpen(false);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            statusOpen(false);
        } else if (event.key === 'Escape') {
            statusOpen(false);
        }
    }

    const prevOpen = React.useRef(openMenu);
    React.useEffect(() => {
        if (prevOpen.current === true && openMenu === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = openMenu;
    }, [openMenu]);

    const { t } = useTranslation()
    const handleChange = (data) => {
        EditEvaluated(data)
    };
    return (
        <Stack direction="row" spacing={2}>
            <div>
                <Button
                    sx={{ display: "flex", height: "45px", padding: "5px 11px" }}
                    variant="dashed-solid"
                    ref={anchorRef}
                    id="composition-button"
                    aria-controls={openMenu ? 'composition-menu' : undefined}
                    aria-expanded={openMenu ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleToggle}
                >
                    <Box sx={{ display: "flex", "align-items": "center", "text-transform": "none" }}>
                        <BtnFilter />
                        <Typography ml="10px" color="#393939">{t('competency.filters')}</Typography>
                    </Box>
                </Button>
                <Popper
                    open={openMenu}
                    anchorEl={anchorRef.current}
                    role={undefined}
                    placement="bottom-start"
                    transition
                    disablePortal
                    style={{ "z-index": "1" }}
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin:
                                    placement === 'bottom-start' ? 'left top' : 'left bottom',
                            }}
                        >
                            <Paper >
                                <ClickAwayListener onClickAway={handleClose}>
                                    <Box px="16px" py="6px"
                                        autoFocusItem={openMenu}
                                        id="composition-menu"
                                        aria-labelledby="composition-button"
                                        onKeyDown={handleListKeyDown}
                                    >
                                        <FormGroup sx={{ ".MuiTypography-root": { color: "#404349" } }}>
                                            <FormControlLabel control={<Checkbox indeterminate={notEvaluated !== evaluated} onChange={e => handleChange("selectAll")} checked={notEvaluated === true && evaluated === true ? true : false} />} label={t('competency.selectAll')} />
                                            <FormControlLabel control={<Checkbox onChange={e => handleChange("notEvaluated")} checked={notEvaluated} />} label={t('competency.notEvaluated')} />
                                            <FormControlLabel control={<Checkbox onChange={e => handleChange("evaluated")} checked={evaluated} />} label={t('competency.evaluated')} />
                                        </FormGroup>
                                    </Box>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </div>
        </Stack>
    );
}